import React, { useState, useContext, useEffect } from 'react'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Layout from '../../components/templates/Layout'
import './Plugins.css'
import { useHistory } from 'react-router-dom'
import AlertContext from '@/product/context/alert/alertContext'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import SecondaryButton from '../../components/atoms/SecondaryButton'
import CustomDialog from '../../components/organisms/Dialog'
import { Button } from '@mui/material'
import { mapData } from '../../common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import ControlHubContext from '../../context/controlHub/controlHubContext'
import { handleRedirectInternal } from '@/product/common/components'
import { createSafeMarkup } from '@/product/common/sanitize'
function Plugins(props) {
    const [expanded, setExpanded] = useState(false)
    const controlHubContext = useContext(ControlHubContext)
    const {
        getAllPlugins,
        responseStatus,
        search_fetch_data,
        requestEmail,
        clearResponse,
    } = controlHubContext

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false)
    }
    const history = useHistory()
    const alertContext = useContext(AlertContext)
    const [customFields, setCustomFields] = useState([])
    const [configDetails, setConfigDetails] = useState(false)
    const [configValues, setConfigValues] = useState([])
    const [activateModal, setActivateModal] = useState(false)
    const [videoModal, setVideoModal] = useState(false)
    const [configModal, setConfigModal] = useState(false)
    const [pluginName, setPluginName] = useState('')
    const [pluginVideo, setPluginVideo] = useState('')
    const [pluginData, setPluginData] = useState([])
    const [siteData, setSiteData] = useState([])
    const [thirdParty, setThirdParty] = useState([])
    const { setAlert } = alertContext
    let site_id = global.site_id
    let site_type = global.site_type

    const configPlugin = (name) => {
        setConfigModal(true)
        setPluginName(name)
    }

    const formik = useFormik({
        initialValues: {
            limit: 20,
            page: 1,
            order: '',
            orderby: '',
            filters: {
                site_id: {
                    value: site_id ? site_id : 'LG0001',
                    type: 'in',
                    field: 'sp.site_id',
                },
                site_env: {
                    value: site_type ? site_type : 'production',
                    type: 'in',
                    field: 'sp.site_env',
                },
            },
            primaryTable: 'site_plugins',
        },

        onSubmit: (values) => {
            setIsLoading(true)
            getAllPlugins(values, 'thirdParty')
        },
    })
    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'requestEmail') {
                setAlert(responseStatus.message, responseStatus.status)
            }
        }
        clearResponse()
    }, [responseStatus])

    const activationValidationArray = Yup.object({
        message: Yup.string().required('Required!'),
    })

    const activationFormik = useFormik({
        enableReinitialize: false,
        initialValues: {
            message: '',
        },
        validationSchema: activationValidationArray,
        onSubmit: (values) => {
            values.pluginname = pluginName
            requestEmail(values)
            setActivateModal(false)
        },
    })

    const activatePlugin = (data) => {
        setPluginName(data.title)
        setActivateModal(true)
    }

    const activateVideo = (data) => {
        setPluginVideo(data)
        setVideoModal(true)
    }
    const activationInfo = {
        formik: activationFormik,
        data: [
            {
                label: 'Message',
                name: 'message',
                type: 'text',
                placeholder: 'Enter message',
                class: 'col-12',
            },
        ],
    }

    const configValidationArray = Yup.object({
        accessKey: Yup.string().required('Required!'),
        secretAccessKey: Yup.string().required('Required!'),
    })

    const configFormik = useFormik({
        enableReinitialize: false,
        initialValues: {
            accessKey: '',
            secretAccessKey: '',
        },
        validationSchema: configValidationArray,
        onSubmit: (values) => {},
    })

    const configInfo = {
        formik: configFormik,
        data: [
            {
                label: 'Access code',
                name: 'accessKey',
                type: 'text',
                placeholder: 'Enter your access code',
                class: 'col-12',
            },
            {
                label: 'Secret access code',
                name: 'secretAccessKey',
                type: 'text',
                placeholder: 'Enter your secret access code',
                class: 'col-12',
            },
        ],
    }

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'allThirdParty') {
                setThirdParty(
                    search_fetch_data.records &&
                        search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
                setSiteData(
                    search_fetch_data.config && search_fetch_data.config.length
                        ? search_fetch_data.config
                        : []
                )
            }
        }
    }, [search_fetch_data])

    useEffect(() => {
        if (thirdParty) {
            let apiValues = thirdParty
            if (siteData && siteData.length) {
                apiValues.map((ele) => {
                    siteData.map((value) => {
                        if (value.payments === 1) {
                            if (ele.name === value.name) {
                                ele.enable = value.enable
                                ele.payments = 1
                                ele.max_limit = value.max_limit
                                ele.use_count = value.use_count
                            }
                        }
                    })
                })
            }
            setPluginData(apiValues.length ? apiValues : [])
        }
    }, [thirdParty, siteData])

    useEffect(() => {
        getAllPlugins(formik.values, 'allThirdParty')
    }, [])
    const customFormik = useFormik({
        initialValues: {},
        validateOnBlur: false,
        // validationSchema: validationArray,
        onSubmit: (values) => {},
    })
    const showConfigFields = (value) => {
        const editValue = configValues.find(
            (ele) => ele.variable === value.title
        )

        const convertedValue =
            typeof editValue === 'undefined'
                ? {}
                : editValue.plugin_fields_value
                ? JSON.parse(editValue.plugin_fields_value)
                : {}

        const Fields = []
        for (const key in convertedValue) {
            let field = {}
            field.name = key
            field.label = key
            field.disabled = true
            field.formik = customFormik
            customFormik.values[key] = convertedValue[key]
                ? convertedValue[key]
                : ''
            Fields.push(field)
        }

        setCustomFields(Fields)
        setConfigDetails(true)
    }
    const makePayment = (data) => {
        handleRedirectInternal(
            history,
            `billing/${data.name ? data.name : 'all'}/0`
        )
    }
    return (
        <>
            <Layout
                noUI={props.noUI || false}
                renderSidePanelDefault={props.renderSidePanelDefault || false}
            >
                <div className="plugins">
                    {pluginData.map((data, index) => (
                        <Accordion
                            expanded={expanded === `panel${index}`}
                            onChange={handleChange(`panel${index}`)}
                        >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel${index}bh-content`}
                                id={`panel${index}bh-header`}
                            >
                                <img
                                    src={`${global.controlhub_url}/uploads/product/${data.avatar}`}
                                    alt={data.title}
                                />
                                <h4>{data.title}</h4>
                                <h6>{data.short_description}</h6>
                            </AccordionSummary>
                            <AccordionDetails>
                                <p
                                    dangerouslySetInnerHTML={createSafeMarkup(
                                        data.description
                                    )}
                                ></p>
                                <div className="statusVersion">
                                    {data.payments ? (
                                        <>
                                            <p>
                                                Status:{' '}
                                                <span
                                                    className={`${
                                                        data.enable
                                                            ? 'active'
                                                            : 'inactive'
                                                    }`}
                                                >
                                                    {data.enable
                                                        ? 'Active'
                                                        : 'In-active'}
                                                </span>
                                            </p>
                                        </>
                                    ) : (
                                        <>
                                            <p>
                                                Status:{' '}
                                                <span
                                                    className={`${
                                                        data.active
                                                            ? 'active'
                                                            : 'inactive'
                                                    }`}
                                                >
                                                    {data.active
                                                        ? 'Active'
                                                        : 'In-active'}
                                                </span>
                                            </p>
                                        </>
                                    )}

                                    <p>
                                        Version: <span>{data.version}</span>
                                    </p>
                                    {data.payments ? (
                                        <>
                                            {`Limit:${data.max_limit}`}
                                            {`Usage:${data.use_count}`}
                                            {`Balance:${
                                                data.max_limit - data.use_count
                                            }`}
                                            {data.enable ? (
                                                <div className="pluginsAct">
                                                    <SecondaryButton
                                                        onClick={() =>
                                                            activatePlugin(
                                                                data.title
                                                            )
                                                        }
                                                        label="De-activate"
                                                    />
                                                </div>
                                            ) : (
                                                <div className="pluginsAct">
                                                    <SecondaryButton
                                                        onClick={() =>
                                                            makePayment(data)
                                                        }
                                                        label="Make Payment"
                                                    />
                                                    <PrimaryButton
                                                        onClick={() =>
                                                            activatePlugin(
                                                                data.title
                                                            )
                                                        }
                                                        label="Activate Plugin"
                                                    />
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {data.active ? (
                                                <div className="pluginsAct">
                                                    <SecondaryButton
                                                        onClick={() =>
                                                            activatePlugin(
                                                                data.title
                                                            )
                                                        }
                                                        label="De-activate"
                                                    />
                                                </div>
                                            ) : (
                                                <div className="pluginsAct">
                                                    {/* <SecondaryButton
                                                onClick={() =>
                                                    configPlugin(data.title)
                                                }
                                                label="Configuration"
                                            /> */}
                                                    {/* <SecondaryButton
                                                onClick={() => configPlugin(data.title)}
                                                label="Configuration"
                                            /> */}
                                                    {data.title ===
                                                    'Shopify Listing' ? (
                                                        <SecondaryButton
                                                            onClick={() =>
                                                                activateVideo(
                                                                    'https://auction-io.ecommerce.auction/uploads/blog/8a54a7c91bfa8bad5b17f204723d4d1a.mp4'
                                                                )
                                                            }
                                                            label="Watch Video"
                                                        />
                                                    ) : data.title ===
                                                      'Ebay Listing' ? (
                                                        <SecondaryButton
                                                            onClick={() =>
                                                                activateVideo(
                                                                    'https://auction-io.ecommerce.auction/uploads/blog/ae2acdea2061531c1e0d91beb15c0d11.mp4'
                                                                )
                                                            }
                                                            label="Watch Video"
                                                        />
                                                    ) : null}

                                                    <PrimaryButton
                                                        onClick={() =>
                                                            activatePlugin(
                                                                data.title
                                                            )
                                                        }
                                                        label="Activate Plugin"
                                                    />
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </div>
            </Layout>

            <CustomDialog
                className="pluginsModal"
                title={`Plugin Video`}
                open={videoModal}
                function={() => setVideoModal(!videoModal)}
            >
                {pluginVideo ? (
                    <video width="100%" height="500" controls>
                        <source src={pluginVideo} type="video/mp4" />
                    </video>
                ) : null}

                <div className="actionWrapper">
                    <Button onClick={() => setVideoModal(false)}>Close</Button>
                </div>
            </CustomDialog>

            <CustomDialog
                className="pluginsModal"
                title={`Activate Plugin`}
                open={activateModal}
                function={() => setActivateModal(!activateModal)}
            >
                <h4>
                    You are about to send a request Email to activate{' '}
                    <strong>{pluginName}</strong> plugin.
                </h4>
                <h4>
                    Please enter your activation code to enable this plugin.
                </h4>
                <form onSubmit={activationFormik.handleSubmit}>
                    <div className="row">{mapData(activationInfo)}</div>
                    <small>
                        If you do not have an activation code, Please contact
                        the administrator.
                    </small>

                    <div className="actionWrapper">
                        <Button onClick={() => setActivateModal(false)}>
                            Cancel
                        </Button>
                        <PrimaryButton type="submit" label="Submit" />
                    </div>
                </form>
            </CustomDialog>

            {/* <CustomDialog
                className="configModal"
                title={`Update Plugin Configuration`}
                open={configModal}
                function={() => setConfigModal(!configModal)}
            >
                <h4>
                    Please enter your configuration information to enable{' '}
                    <strong>{pluginName}.</strong>
                </h4>
                <form onSubmit={configFormik.handleSubmit}>
                    <div className="row">{mapData(configInfo)}</div>
                    <small>
                        You can find your configuration information on your
                        Plugin dashboard.
                        <br />
                        For instance, You need to login to your {
                            pluginName
                        }{' '}
                        dashboard to fetch your {pluginName} configuration
                        details.
                    </small>
                    <div className="actionWrapper">
                        <Button onClick={() => setConfigModal(false)}>
                            Cancel
                        </Button>
                        <PrimaryButton type="submit" label="Confirm" />
                    </div>
                </form>
            </CustomDialog> */}
            <CustomDialog
                className="pluginsModal"
                title={`ThirdParty Config Details`}
                open={configDetails}
                function={() => setConfigDetails(!configDetails)}
            >
                <form onSubmit={customFormik.handleSubmit}>
                    {customFields.length ? (
                        <div className="row">{mapData(customFields)}</div>
                    ) : (
                        <h4>No configurations found</h4>
                    )}

                    <div className="actionWrapper">
                        <SecondaryButton
                            onClick={() => {
                                setConfigDetails(false)
                            }}
                        >
                            OK
                        </SecondaryButton>
                    </div>
                </form>
            </CustomDialog>
        </>
    )
}

export default Plugins
